import "./JapaneseStaff.module.css";
import Staff from "./sections/Staff";
import Footer from "@/reusable_sections/Footer";
export default function JapaneseStaffPage() {
  return <div>
      <Staff />
      <Footer />
    </div>;
}